module.exports = __webpack_public_path__ + "img/xz.3a80189d.svg";